import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravellerrentinbelgaum() {



    const cardData = {




keyword: "Tempo Traveller Rent in Belgaum",

headingDescription: "Belgaum Taxi Service provides comfortable and reliable Tempo Traveller rent in Belgaum for family tours, corporate trips, group outings, wedding transportation, pilgrimage tours, airport transfers, and long-distance journeys. Our Tempo Traveller services are ideal for groups who need spacious seating, extra luggage capacity, and a comfortable travel experience. We offer different seating options including 9-seater, 12-seater, 16-seater, and larger group vehicles according to your travel requirements. Whether you need a Tempo Traveller for local sightseeing, one-day trips, weekend getaways, or multi-day outstation tours, our vehicles are well-maintained and driven by experienced chauffeurs. With doorstep pickup, flexible booking options, transparent pricing, comfortable interiors, and 24/7 customer support, Belgaum Taxi Service ensures a safe and enjoyable journey for families, corporate teams, and groups. Our Tempo Traveller rental services are available for popular routes across Karnataka, Goa, Maharashtra, and nearby destinations, making group travel easy and convenient.",

topPlaces: [
  
    {
    title: "Mysore",
    description: "Mysore is famous for Mysore Palace, Chamundi Hills, cultural heritage, and royal history. It is a preferred destination for family and group sightseeing tours."
  },
    {
    title: "Goa",
    description: "Goa is a favorite group travel destination from Belgaum, offering beaches, resorts, churches, water sports, and sightseeing attractions. Tempo Travellers are ideal for family and group trips to Goa."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site known for ancient temples, historical ruins, and unique landscapes. It is a popular destination for group heritage tours from Belgaum."
  },

  {
    title: "Coorg",
    description: "Coorg is a beautiful hill station known for coffee plantations, waterfalls, forests, and peaceful landscapes. Tempo Traveller rentals are suitable for group vacations to Coorg."
  },
  {
    title: "Jog Falls",
    description: "Jog Falls is one of India's highest waterfalls, surrounded by scenic greenery and natural beauty. It is a popular weekend destination for group travelers."
  },
  {
    title: "Murudeshwar",
    description: "Murudeshwar is a coastal pilgrimage destination famous for the Shiva statue, temple, beach, and Arabian Sea views, attracting families and groups throughout the year."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination known for Sai Baba Temple. Many families and groups prefer Tempo Traveller services for comfortable religious tours."
  },
  {
    title: "Nashik",
    description: "Nashik is known for temples, vineyards, cultural attractions, and religious importance. It is a popular outstation destination for group travel."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a scenic hill station near Mahabaleshwar, famous for Table Land, viewpoints, and pleasant weather, making it ideal for group holidays."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill station known for waterfalls, caves, viewpoints, and green valleys. It is a preferred weekend destination for families and corporate groups."
  }
],




"services": [
  {
    "name": "Tempo Traveller on Rent in Belgaum",
    "description": "Book Tempo Traveller on Rent in Belgaum for group tours, family trips, corporate travel, weddings, and outstation journeys with comfortable seating and professional drivers."
  },
  {
    "name": "Tempo Traveller for Rent in Belgaum",
    "description": "Hire Tempo Traveller for Rent in Belgaum with AC vehicles, spacious interiors, experienced chauffeurs, and reliable transportation for groups."
  },
  {
    "name": "Tempo Traveller Rent in Belgaum",
    "description": "Choose Tempo Traveller Rent in Belgaum for sightseeing tours, pilgrimage trips, holiday travel, and customized group transportation."
  },
  {
    "name": "Tempo Traveller Rent Per Km in Belgaum",
    "description": "Check Tempo Traveller Rent Per Km in Belgaum with transparent pricing, flexible packages, and multiple seating options for every journey."
  },
  {
    "name": "Belgaum to Goa 14 Seater Tempo Traveller",
    "description": "Book Belgaum to Goa 14 Seater Tempo Traveller for family vacations, group trips, and comfortable travel with spacious seating."
  },
  {
    "name": "Belgaum to Pune 14 Seater Tempo Traveller",
    "description": "Travel with Belgaum to Pune 14 Seater Tempo Traveller offering AC comfort, professional drivers, and hassle-free group transportation."
  },
  {
    "name": "Belgaum to Bangalore 14 Seater Traveller",
    "description": "Reserve Belgaum to Bangalore 14 Seater Traveller for business groups, family travel, and long-distance journeys."
  },
  {
    "name": "Belgaum to Mahabaleshwar 14 Seater Traveller",
    "description": "Hire Belgaum to Mahabaleshwar 14 Seater Traveller for sightseeing, holidays, and comfortable hill station trips."
  },
  {
    "name": "Belgaum to Shirdi 14 Seater Traveller",
    "description": "Book Belgaum to Shirdi 14 Seater Traveller for safe pilgrimage travel with spacious seating and experienced chauffeurs."
  },
  {
    "name": "Group Tour 14 Seater Traveller Belgaum",
    "description": "Choose Group Tour 14 Seater Traveller Belgaum for friends, families, and corporate groups with comfortable travel facilities."
  },
  {
    "name": "14 Seater Tourist Van Belgaum",
    "description": "Hire 14 Seater Tourist Van Belgaum for local sightseeing, outstation trips, and group transportation."
  },
  {
    "name": "14 Seater Traveller Near Me Belgaum",
    "description": "Find 14 Seater Traveller Near Me Belgaum with quick booking, nearby pickup, and reliable group travel service."
  },
  {
    "name": "Luxury Group Transport Belgaum",
    "description": "Book Luxury Group Transport Belgaum with premium vehicles, comfortable seating, and professional drivers for special occasions."
  },
  {
    "name": "Force Traveller 14 Seater Belgaum",
    "description": "Reserve Force Traveller 14 Seater Belgaum for family tours, corporate trips, weddings, and outstation travel."
  },
  {
    "name": "Belgaum to Goa 17 Seater Tempo Traveller",
    "description": "Travel with Belgaum to Goa 17 Seater Tempo Traveller for large groups with luxury seating and comfortable road journeys."
  },
  {
    "name": "Belgaum to Pune 17 Seater Tempo Traveller",
    "description": "Book Belgaum to Pune 17 Seater Tempo Traveller for group travel, corporate trips, and family vacations."
  },
  {
    "name": "Belgaum to Bangalore 17 Seater Traveller",
    "description": "Choose Belgaum to Bangalore 17 Seater Traveller for spacious group transportation with AC comfort and experienced drivers."
  },
  {
    "name": "Belgaum to Mahabaleshwar 17 Seater Traveller",
    "description": "Reserve Belgaum to Mahabaleshwar 17 Seater Traveller for scenic trips, holidays, and comfortable group journeys."
  },
  {
    "name": "Belgaum to Shirdi 17 Seater Traveller",
    "description": "Book Belgaum to Shirdi 17 Seater Traveller for pilgrimage tours with safe driving and premium comfort."
  },
  {
    "name": "Group Tour Tempo Traveller Belgaum",
    "description": "Hire Group Tour Tempo Traveller Belgaum for sightseeing, family outings, corporate events, and holiday packages."
  },
  {
    "name": "17 Seater Tourist Van Belgaum",
    "description": "Choose 17 Seater Tourist Van Belgaum for group tours, airport transfers, and long-distance travel."
  },
  {
    "name": "17 Seater Traveller Near Me Belgaum",
    "description": "Book 17 Seater Traveller Near Me Belgaum with easy availability, comfortable vehicles, and professional service."
  },
  {
    "name": "Luxury Group Vehicle Belgaum",
    "description": "Reserve Luxury Group Vehicle Belgaum for premium travel experiences, events, tours, and corporate transportation."
  },
  {
    "name": "Force Traveller 17 Seater Belgaum",
    "description": "Hire Force Traveller 17 Seater Belgaum for large group journeys with spacious interiors and comfortable seating."
  },
  {
    "name": "Tempo Traveller Rent in Belgaum",
    "description": "Book Tempo Traveller Rent in Belgaum with multiple seating options, affordable packages, and reliable chauffeur service."
  },
  {
    "name": "Tempo Traveller on Rent in Belgaum",
    "description": "Choose Tempo Traveller on Rent in Belgaum for weddings, picnics, family tours, and corporate travel."
  },
  {
    "name": "Tempo Traveller Rental Belgaum",
    "description": "Hire Tempo Traveller Rental Belgaum for local and outstation travel with comfortable AC vehicles."
  },
  {
    "name": "Tempo Traveller Hire Belgaum",
    "description": "Reserve Tempo Traveller Hire Belgaum with professional drivers, clean vehicles, and flexible travel plans."
  },
  {
    "name": "Tempo Traveller Booking Belgaum",
    "description": "Complete Tempo Traveller Booking Belgaum with instant confirmation, multiple vehicle choices, and 24x7 assistance."
  },
  {
    "name": "Online Tempo Traveller Booking Belgaum",
    "description": "Book Online Tempo Traveller Booking Belgaum with easy reservations, secure booking, and reliable transportation."
  },
  {
    "name": "Luxury Tempo Traveller Belgaum",
    "description": "Travel with Luxury Tempo Traveller Belgaum featuring premium interiors, AC comfort, and spacious seating."
  },
  {
    "name": "AC Tempo Traveller Belgaum",
    "description": "Book AC Tempo Traveller Belgaum for comfortable journeys, group tours, and long-distance travel."
  },
  {
    "name": "Tempo Traveller Cab Service Belgaum",
    "description": "Choose Tempo Traveller Cab Service Belgaum for family trips, corporate events, weddings, and sightseeing tours."
  },
  {
    "name": "Tempo Traveller Rental Service Belgaum",
    "description": "Reserve Tempo Traveller Rental Service Belgaum with flexible packages and dependable group transportation."
  },
  {
    "name": "Outstation Tempo Traveller Belgaum",
    "description": "Book Outstation Tempo Traveller Belgaum for holiday trips, pilgrimage tours, and interstate travel."
  },
  {
    "name": "Tempo Traveller for Family Trip Belgaum",
    "description": "Hire Tempo Traveller for Family Trip Belgaum with comfortable seating, luggage space, and safe travel."
  },
  {
    "name": "Tempo Traveller for Group Tour Belgaum",
    "description": "Choose Tempo Traveller for Group Tour Belgaum for friends, families, and large groups."
  },
  {
    "name": "Tempo Traveller for Wedding Belgaum",
    "description": "Book Tempo Traveller for Wedding Belgaum for guest transportation and special event travel."
  },
  {
    "name": "Corporate Tempo Traveller Belgaum",
    "description": "Reserve Corporate Tempo Traveller Belgaum for office outings, business events, and employee transportation."
  },
  {
    "name": "Tempo Traveller for Picnic Belgaum",
    "description": "Hire Tempo Traveller for Picnic Belgaum for comfortable weekend trips and group outings."
  },
  {
    "name": "Airport Tempo Traveller Belgaum",
    "description": "Book Airport Tempo Traveller Belgaum for group airport transfers with timely pickup and drop services."
  },
  {
    "name": "One Way Tempo Traveller Belgaum",
    "description": "Choose One Way Tempo Traveller Belgaum for direct group travel with affordable pricing and reliable service."
  },
  {
    "name": "Round Trip Tempo Traveller Belgaum",
    "description": "Reserve Round Trip Tempo Traveller Belgaum with flexible schedules, comfortable rides, and professional chauffeurs."
  }
],

"tableData": [
  ["Tempo Traveller on Rent in Belgaum", "Tempo Traveller for Rent in Belgaum"],
  ["Tempo Traveller Rent in Belgaum", "Tempo Traveller Rent Per Km in Belgaum"],
  ["Belgaum to Goa 14 Seater Tempo Traveller", "Belgaum to Pune 14 Seater Tempo Traveller"],
  ["Belgaum to Bangalore 14 Seater Traveller", "Belgaum to Mahabaleshwar 14 Seater Traveller"],
  ["Belgaum to Shirdi 14 Seater Traveller", "Group Tour 14 Seater Traveller Belgaum"],
  ["14 Seater Tourist Van Belgaum", "14 Seater Traveller Near Me Belgaum"],
  ["Luxury Group Transport Belgaum", "Force Traveller 14 Seater Belgaum"],
  ["Belgaum to Goa 17 Seater Tempo Traveller", "Belgaum to Pune 17 Seater Tempo Traveller"],
  ["Belgaum to Bangalore 17 Seater Traveller", "Belgaum to Mahabaleshwar 17 Seater Traveller"],
  ["Belgaum to Shirdi 17 Seater Traveller", "Group Tour Tempo Traveller Belgaum"],
  ["17 Seater Tourist Van Belgaum", "17 Seater Traveller Near Me Belgaum"],
  ["Luxury Group Vehicle Belgaum", "Force Traveller 17 Seater Belgaum"],
  ["Tempo Traveller Rental Belgaum", "Tempo Traveller Hire Belgaum"],
  ["Tempo Traveller Booking Belgaum", "Online Tempo Traveller Booking Belgaum"],
  ["Luxury Tempo Traveller Belgaum", "AC Tempo Traveller Belgaum"],
  ["Tempo Traveller Cab Service Belgaum", "Outstation Tempo Traveller Belgaum"],
  ["Tempo Traveller for Family Trip Belgaum", "Tempo Traveller for Group Tour Belgaum"],
  ["Tempo Traveller for Wedding Belgaum", "Corporate Tempo Traveller Belgaum"],
  ["Tempo Traveller for Picnic Belgaum", "Airport Tempo Traveller Belgaum"],
  ["One Way Tempo Traveller Belgaum", "Round Trip Tempo Traveller Belgaum"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Tempo Traveller Rent in Belgaum",
    WhyChoosedescription: "Belgaum Taxi Service provides spacious Tempo Traveller rentals for family trips, group tours, corporate outings, weddings, sightseeing, and long-distance journeys."
  },
  {
    WhyChooseheading: "Multiple Seating Options Available",
    WhyChoosedescription: "Choose from 9, 12, 16, and larger seating capacity Tempo Travellers based on your group size, luggage requirements, and travel plans."
  },
  {
    WhyChooseheading: "Ideal for Group Travel",
    WhyChoosedescription: "Our Tempo Travellers are perfect for family vacations, friends' trips, pilgrimage tours, corporate events, and group transportation needs."
  },
  {
    WhyChooseheading: "Pickup from Any Location in Belgaum",
    WhyChoosedescription: "Get convenient pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby areas with comfortable travel arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe Journeys",
    WhyChoosedescription: "Our professional chauffeurs ensure safe driving, route knowledge, punctual service, and a comfortable experience throughout your journey."
  },
  {
    WhyChooseheading: "Suitable for Local & Outstation Trips",
    WhyChoosedescription: "Hire a Tempo Traveller for Goa trips, Bangalore tours, Pune travel, Mumbai journeys, pilgrimage routes, and multi-day sightseeing packages."
  },
  {
    WhyChooseheading: "Affordable Rental Packages",
    WhyChoosedescription: "Select flexible hourly, daily, one-way, and multi-day Tempo Traveller rental packages with transparent pricing and reliable service."
  },
  {
    WhyChooseheading: "24/7 Booking Support",
    WhyChoosedescription: "Reserve your Tempo Traveller anytime with quick confirmation and dedicated assistance for hassle-free group travel."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Tempo Traveller Rent in Belgaum?",
    answer: "Yes, we provide Tempo Traveller rental services in Belgaum for family trips, group tours, corporate travel, weddings, and outstation journeys."
  },
  {
    question: "What seating options are available in Tempo Traveller?",
    answer: "We provide different seating options including 9-seater, 12-seater, 16-seater, and larger Tempo Travellers according to group requirements."
  },
  {
    question: "Can I hire a Tempo Traveller for outstation trips?",
    answer: "Yes, Tempo Travellers are available for destinations like Goa, Bangalore, Pune, Mumbai, Kerala, Dandeli, and other popular routes."
  },
  {
    question: "Is Tempo Traveller suitable for family vacations?",
    answer: "Yes, the spacious seating, comfortable interiors, and luggage space make it an ideal choice for family holidays and group travel."
  },
  {
    question: "Do you provide Tempo Traveller for corporate events?",
    answer: "Yes, we offer Tempo Traveller services for corporate outings, employee transportation, meetings, conferences, and business events."
  },
  {
    question: "Can I book a Tempo Traveller for wedding functions?",
    answer: "Yes, Tempo Traveller rental is available for weddings, guest transportation, and special occasions in and around Belgaum."
  },
  {
    question: "Is driver included with Tempo Traveller rental?",
    answer: "Yes, professional drivers are provided with Tempo Traveller rentals to ensure safe and comfortable travel."
  },
  {
    question: "Are toll and parking charges included in the rental fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Is Tempo Traveller rental available 24/7 in Belgaum?",
    answer: "Yes, our Tempo Traveller booking service is available 24 hours a day for local and outstation travel requirements."
  },
  {
    question: "How can I book a Tempo Traveller Rent in Belgaum?",
    answer: "Share your travel date, pickup location, destination, passenger count, and preferred vehicle type to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Desai",
    feedback: "We hired a Tempo Traveller for our family trip from Belgaum. The vehicle was spacious, clean, and the driver made our long journey comfortable and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Patil",
    feedback: "Excellent group travel service with a well-maintained Tempo Traveller and professional driver. The entire booking process was smooth and convenient.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller Rent in Belgaum",
  "image": "https://www.belgaumtaxiservice.com/assets/images/tempo-traveller-rent-in-belgaum.webp",
  "description":
    "Book Tempo Traveller Rent in Belgaum with Belgaum Taxi Service for comfortable group travel solutions. We provide 9 seater, 12 seater, 14 seater, and luxury Tempo Traveller rentals for family trips, corporate travel, pilgrimage tours, weddings, and outstation journeys from Belgaum to Goa, Pune, and other destinations with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/tempo-traveller-rent-in-belgaum"
  }
};





    return (
        <div>


<Helmet>
  <title>Tempo Traveller Rent in Belgaum | 14 Seater Traveller | +91 8722158435</title>

  <meta
    name="description"
    content="Book Tempo Traveller Rent in Belgaum with Belgaum Taxi Service for group travel, family tours, corporate trips, weddings, and outstation journeys. Hire 9, 12, and 14 seater Tempo Traveller with professional drivers for Belgaum to Goa, Pune, and other destinations available 24x7."
  />

  <meta
    name="keywords"
    content="Tempo traveller on rent in belgaum, Tempo traveller for rent in belgaum, Tempo traveller rent in belgaum, Tempo traveller rent per km in belgaum, Belgaum to Goa 14 Seater Tempo Traveller, Belgaum to Pune 14 Seater Tempo Traveller, Tempo Traveller Booking Belgaum, Tempo Traveller Hire Belgaum, Luxury Tempo Traveller Belgaum, Outstation Tempo Traveller Belgaum"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravellerrentinbelgaum;